import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import api from '@appbase/api'

/**
 * 이 페이지는 타 시스템과 연동하는 전자결재 업무 프로세스에 사용됩니다.
 * 수정 시 참고바랍니다.
 */

declare type ErrorParam = {
    title: string,
    message: string,
    type: string, // undefined: error view, 1: login view
    returnUrl: string, // to redirect (encoded value)
}

@Component({
    
})
export default class ErrorView  extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    loaded: boolean = false;
    errorTitle: string = this.$t('오류').toString();
    errorMessage: string = '';
    type: string | null  = null;
    returnUrl: string = '';
    userLang: string = 'ko';

    // ─── Methods ─────────────────────────────────────────────────────────

    
    load() {
        const _this = this;
        const { query } = this.$route;
        if(query.data){
            try{
                const data : ErrorParam = JSON.parse(decodeURIComponent(query.data.toString()));
                if(data.type != undefined){
                    this.type = data.type;
                    switch(this.type){
                        case '1':
                            this.returnUrl = data.returnUrl;
                            api.auth.getCurrentUserConfig().then((userConfig) =>{
                                _this.userLang = userConfig.language.split('-')[0];
                            })
                            break;
                    }

                    this.loaded = true;
                }
                else{
                    this.handleError(new Error(data.title), data.message);
                }
            }
            catch(err){
                this.handleError(err, (err as Error).message);
            }
        }
        else{
            this.handleError(new Error('[NOT FOUND ERROR MESSAGE]'), '[NOT FOUND ERROR MESSAGE]');
        }
    }
    
    handleError(err: any, msg?: string){
        console.error(err);
        console.log(msg);
        if(msg != undefined && msg.length > 0){
            this.errorMessage = msg;
        }
        else{
            this.errorMessage = '';
        }
        
        this.loaded = true;
    }

    /**
     * 해당 URL 로 페이지를 이동시킵니다.
     * @param url 
     */
    goToPage(url: string){
        try{
            var targetUrl = decodeURIComponent(url);
            if(targetUrl.indexOf('?') > -1){
                targetUrl += '&EumRedirect=1';
            }
            else{
                targetUrl += '?EumRedirect=1';
            }
            if (targetUrl.startsWith('http://') || targetUrl.startsWith('https://')) {
                location.href = targetUrl;
            }
            else{
                location.href = location.origin + targetUrl;
            }
        }
        catch(err){
            this.handleError(err);
        }
    }

    /**
     * 로그인 처리하도록 이동
     */
    goToLogin(){
        //logout
        // ADFS 사용 시에는 의미없음. 메인으로 이동하도록.
        api.auth.logout().then(() => {
            this.goToPage(this.returnUrl);
        }).catch((err: any) => {
            this.handleError(err, err.message);
        })
    }

    goToHome(){
        var hostname = location.host;
        if(hostname != ''){
            location.href = 'https://' + hostname;
        }
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created(){
        this.load();
    }
}